import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';
import SEO from '../SEO/SEO';

const Redirect = ({ intl }) => {
  return <SEO title={intl.formatMessage({ id: 'seo.title.index' })} lang={intl.locale} />;
};

export default injectIntl(Redirect);
